import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import DashboardService from "../../../../services/OrderingServices/DashboardService";
import NumberWithCommas from "../../../../pages/Pages/Starter/NumberWithCommas";

const CreditWidgets = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      // Get today's date in YYYY-MM-DD format
      const today = new Date().toISOString().split("T")[0];

      const response = await DashboardService.getDayBookSummary(today, today);
      const transformedData = [
        {
          label: "Total Sales",
          counter: response.totalSales,
          icon: "ri-money-dollar-circle-line",
          // name: "View Sales",
          color: "#0D47A1",
          backgroundColor: "rgba(13, 71, 161, 0.1)", // soft blue
          textColor: "#000",
          bg: "#FFFFFF",
        },
        {
          label: "Credit Sales",
          counter: response.totalCreditSales,
          icon: "ri-bank-card-line",
          // name: "View Credit Sales",
          color: "#C62828",
          backgroundColor: "rgba(198, 40, 40, 0.1)", // soft red
          textColor: "#000",
          bg: "#FFFFFF",
        },
        {
          label: "Total Amount",
          counter: response.totalAmount,
          icon: "ri-calculator-line",
          // name: "View Summary",
          color: "#4A148C",
          backgroundColor: "rgba(74, 20, 140, 0.1)", // soft purple
          textColor: "#000",
          bg: "#FFFFFF",
        },

        {
          label: "Discount Amount",
          counter: response.discountAmount,
          icon: "ri-wallet-2-line",
          // name: "View Discounts",
          color: "#F57C00",
          backgroundColor: "rgba(245, 124, 0, 0.1)", // soft orange
          textColor: "#000",
          bg: "#FFFFFF",
        },
        {
          label: "Est. Sales",
          counter: response.orderSalesAmount,
          icon: "ri-restaurant-line",
          // name: "View Orders",
          color: "#1B5E20",
          backgroundColor: "rgba(27, 94, 32, 0.1)", // soft green
          textColor: "#000",
          bg: "#FFFFFF",
        },
        {
          label: "Total Expenses",
          counter: response.totalExpenses,
          icon: "ri-wallet-line",
          // name: "View Expenses",
          color: "#D32F2F",
          backgroundColor: "rgba(211, 47, 47, 0.1)", // soft red
          textColor: "#000",
          bg: "#FFFFFF",
        },
      ];

      setData(transformedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="">
      <Row>
        {data.map((item, key) => (
          <Col lg={2} md={6} key={key} className="">
            <Card
              className="card-animate border-0 shadow-sm"
              style={{
                borderRadius: "1rem",
                transition: "0.3s ease-in-out",
                cursor: "pointer",
                background: item.bg,
                backgroundColor: item.bg,
              }}
              onClick={() => navigate(item.link)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.03)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <CardBody>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <p
                    className="fw-semibold mb-0 text-truncate"
                    style={{ color: item.color }}
                  >
                    {item.label}
                  </p>
                </div>

                <div className="d-flex justify-content-between align-items-end mt-3">
                  <div>
                    <h4
                      className="fs-3 fw-bold mb-1"
                      style={{ color: item.color }}
                    >
                      <NumberWithCommas number={item.counter} />
                    </h4>
                    <span className="fs-13" style={{ color: item.color }}>
                      {item.name}
                    </span>
                  </div>
                  {/* Avatar Icon */}
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      backgroundColor: `${item.color}15`,
                      width: "32px",
                      height: "32px",
                    }}
                  >
                    <i
                      className={`fs-6 ${item.icon}`}
                      style={{
                        color: item.color,
                      }}
                    ></i>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CreditWidgets;
